import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuthenticationService } from 'src/app/core/modules/auth-core/data/service/authentication.service';
import { BasePage } from 'src/app/core/base-page';

@Component({
  selector: 'app-reject-reason-detail',
  templateUrl: './reject-reason-detail.page.html',
  styleUrls: ['./reject-reason-detail.page.scss'],
})
export class RejectReasonDetailPage extends BasePage {
  @Input() rejectReason: string;

  constructor(
    authService: AuthenticationService,
    private modalCtrl: ModalController,
  ) {
    super(authService);
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
